module.exports = __webpack_public_path__ + "assets/6815b4c06d5491e9cac01801274666e9.png";